import { cn } from '@/lib/utils';

const gapMap = {
  sm: 'gap-3',
  md: 'gap-6',
  lg: 'gap-8',
} as const;

interface TwoColumnLayoutProps {
  main: React.ReactNode;
  sidebar: React.ReactNode;
  sidebarSticky?: boolean;
  className?: string;
  gap?: 'sm' | 'md' | 'lg';
}

export function TwoColumnLayout({
  main,
  sidebar,
  sidebarSticky = true,
  className,
  gap = 'md',
}: TwoColumnLayoutProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 md:grid md:grid-cols-3',
        gapMap[gap],
        className,
      )}
    >
      <div className="md:col-span-2">{main}</div>
      <div className={cn('md:col-span-1', sidebarSticky && 'md:sticky md:top-4 md:self-start')}>
        {sidebar}
      </div>
    </div>
  );
}
